<div class="{{ className }}">
  @if (!hideLabel) {
    <label [attr.for]="effectiveInputId" [attr.id]="effectiveInputId + '-a11y-label'">{{ label | translate }}</label>
  }
  @if (form && controlName) {
    <app-auto-complete
      [inputId]="effectiveInputId"
      [labelElementId]="!hideLabel ? effectiveInputId + '-a11y-label' : undefined"
      [ariaLabel]="label | translate"
      [describedBy]="validationDescribedById"
      [ariaInvalid]="ariaInvalid"
      (selectedItemChange)="onSelectChangeTeacher($event)"
      (searchChange)="onSearchChangeTeacher($event)"
      [itemsData]="owners"
      [selectedItem]="form.get(controlName)?.value"
      [minTermLength]="1"
      [disabled]="disabled"
    ></app-auto-complete>
  }
</div>
